module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABQCAYAAABrjzfBAAABLUlEQVRoQ+3YsQ7CMAyE4XhHvP9LwoBYmIKK2qUCqc7duRE6JoYavv71UCXa5J+Y3NcMRJ+QC7ogWgCd9w66IFoAnfcOuiBaAJ33DrogWgCd9w66IFpgm++9X5bvEfHM/GbJDq646wp7ZJBy4A63GF8RcTtaUQr8hmut3SOinw5k4D47e/ROMtexcBIgE0cHsnFUoAJHA6pwFKASBwPVOAhYgRsGVuGGgJW4NLAalwKegfsv4HI3Z1RMv81UI9PA6pJDwErkMLAKCQErkDBQjaQAlUgaUIWkAhVIOpCNlACZSBmQhZQCfyGnOTzajkumPn7bIec8wMwcPO2vle8ggku98qN/NDrvgqPltjkXdEG0ADrvHXRBtAA67x10QbQAOu8ddEG0ADrvHUQLvgEdDsRRnEXFCwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/xiangzuo.png
// module id = W9DQ
// module chunks = 1